const errorHandler = (error: any): string => {
  return error?.data?.detail?.error_message != null
    ? error.data.detail.error_message
    : error?.data?.detail?.msg
      ? error.data.detail.msg
      : 'An error has occurred'
}

export default errorHandler
